module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "top"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-down",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-image gun-mat-lander"
  }, [_c('img', {
    attrs: {
      "src": "/img/4gun_showcase.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('h1', {
    staticClass: "hero-title landing-title"
  }, [_vm._v("The Gun Mattress")]), _vm._v(" "), _c('p', {
    staticClass: "hero-tag"
  }, [_c('em', [_vm._v("Protecting your firearms for over 30 years")])])]), _vm._v(" "), (_vm.cartItems.length > 0) ? _c('router-link', {
    staticClass: "button btn-primary",
    attrs: {
      "to": {
        name: 'review'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Checkout\n                "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1) : _c('router-link', {
    staticClass: "button btn-primary order-now",
    attrs: {
      "to": {
        name: 'order'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Order yours now\n                "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    ref: "scroller",
    staticClass: "main"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "what-is-it"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-section thirds"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "two-third-image"
  }, [_c('image-slider', {
    attrs: {
      "images": [
        '/img/4gun_open.png',
        '/img/4gun_half.png',
        '/img/4gun_closed.png'
      ]
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "fabric"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "hardware"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-section halves"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "half-image"
  }, [_c('image-slider', {
    attrs: {
      "images": [
        '/img/grommets.png',
        '/img/snaps_top.png',
        '/img/snaps_bottom.png'
      ]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "sizes"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Three Sizes")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('product-display'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "colors"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Eleven Colors")]), _vm._v(" "), _c('color-display'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [(_vm.selectedProduct !== null && _vm.selectedColor !== null) ? _c('button', {
    staticClass: "button btn-success",
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v("\n                    Add to cart\n                    "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1) : (_vm.cartItems.length > 0) ? _c('router-link', {
    staticClass: "button btn-primary",
    attrs: {
      "to": {
        name: 'review'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                    Checkout\n                    "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1) : _c('router-link', {
    staticClass: "button btn-primary",
    attrs: {
      "to": {
        name: 'order'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                    Order yours now\n                    "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-third-content"
  }, [_c('h2', {
    staticClass: "hero-title"
  }, [_vm._v("What is it?")]), _vm._v(" "), _c('p', [_vm._v("\n                    Secure this one of a kind mattress to the hood or roof of any vehicle for quick and easy access\n                    to your rifles and shotguns. Your guns are hugged in the grooves of the Gun Mattress and can be\n                    sheltered in a snap with the protective cover flap - the flap is able to be completely\n                    closed and securely snapped shut in the case of rainy, dusty, or muddy conditions.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Designed to keep your guns at arms reach, without sacrificing protection, the 4.5 inches of\n                    dense padding provides superior protection for your firearms,\n                    whether on the trail or out in the field.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Whether you own a truck, Jeep, Side-by-Side ATV, or a custom hunting rig - the gun mattress is\n                    designed to fit on the hood, roof, or in the bed of nearly any vehicle you may own.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Securing it is a cinch. The heavy-duty metal grommets we place around the perimeter of\n                    the mattress allow for versatile and secure placement options through the use of rope or\n                    bungee cord (not included).\n                    Before you buy, please see the "), _c('a', {
    staticStyle: {
      "color": "#46b8da"
    },
    attrs: {
      "href": "#sizes"
    }
  }, [_vm._v("diagrams")]), _vm._v(" for sizes and actual measurements.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-height": "35vh"
    },
    attrs: {
      "src": "/img/4gun_jeep.jpg",
      "height": "300"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-height": "35vh"
    },
    attrs: {
      "src": "/img/6gun_jeep.jpg",
      "height": "300"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-height": "35vh"
    },
    attrs: {
      "src": "/img/8gun_jeep.jpg",
      "height": "300"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-section halves reversed with-border"
  }, [_c('div', {
    staticClass: "half-image"
  }, [_c('img', {
    attrs: {
      "src": "/img/4gun_standing.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "half-content"
  }, [_c('h2', {
    staticClass: "hero-title"
  }, [_vm._v("Heavy Duty Material")]), _vm._v(" "), _c('p', [_vm._v("\n                    All of our materials are hand selected for their strength and durability.\n                    They are also water and mildew and abrasion resistant, quick-drying and easy to clean!\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Recommended care and cleaning instructions:")]), _vm._v(" "), _c('br'), _vm._v("\n                    We recommend storing your mattress in a dry area, away from constant sun exposure.\n                    While these materials are durable, and some UV resistant, we want you to enjoy your\n                    product for many hunting seasons to come.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Spot clean with water on a damp sponge or cloth. If necessary, a mild soap may be used\n                    (DO NOT USE CHLORINE BLEACH). If the mattress should become wet or soaked, please allow\n                    it to dry completely in a well ventilated area before storing.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-content"
  }, [_c('h2', {
    staticClass: "hero-title"
  }, [_vm._v("Durable Hardware")]), _vm._v(" "), _c('p', [_vm._v("\n                    We stamp metal snaps into the top and flap to allow for worry-free protection\n                    of your armament in dusty or rainy conditions. The grommets you'll find around\n                    the perimeter of the gun mattress allow for easy mounting to almost any vehicle.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Our grommets and snaps are made to withstand the most difficult of environments\n                    - constructed of heavy-duty brass coated with black-oxide, they're designed\n                    to provide the ultimate in hole-reinforcement technology. Not only will you not\n                    have to worry  about tears in the fabric, the unique finish of this black-oxide\n                    hardware adds an unmistakably rugged look to your gun mattress.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_c('small', [_c('em', [_vm._v("Click to see dimensions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bbd84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 212
// module chunks = 1